module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isInitialized) ? _c('div', {
    staticClass: "wrapper",
    class: _vm.setClassWrapperCharacter2Select()
  }, [_c('header', {
      staticClass: "header_wrap",
      class: _vm.setClassHeaderCharacter2Select()
    }, [_c('div', {
      staticClass: "header_wrap-left"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.goCancel()
        }
      }
    }, [_vm._v("キャンセル")])]), _c('div', {
      staticClass: "header_wrap-center"
    }, [_c('button', {
      staticClass: "draft-save-btn",
      on: {
        "click": function($event) {
          _vm.saveDraft()
        }
      }
    }, [_vm._v("下書保存")])]), _c('div', {
      staticClass: "header_wrap-right"
    }, [(!_vm.notInput()) ? _c('button', {
      staticClass: "confirmation-btn",
      on: {
        "click": function($event) {
          _vm.goPreview()
        }
      }
    }, [_vm._v("確認画面へ")]) : _c('button', {
      staticClass: "confirmation-btn unavailable"
    }, [_vm._v("確認画面へ")])])]), [_c('div', {
      staticClass: "es_mycard"
    }, [_c('div', {
      staticClass: "es_mycard_wrap",
      on: {
        "click": function($event) {
          _vm.setDisplayInit()
        }
      }
    }, [_c('div', {
      staticClass: "es_mycard_background"
    }, [_c('img', {
      attrs: {
        "src": _vm.getBackgroundImageByImageName(_vm.card.background_path)
      }
    })]), _c('div', {
      staticClass: "get_user_box"
    }, [_c('div', {
      staticClass: "get_user_box_img"
    }, [_c('img', {
      attrs: {
        "src": _vm.getUserImage(_vm.card.get_user_image)
      }
    })]), _c('div', {
      staticClass: "get_user_box_body"
    }, [_c('p', {
      staticClass: "get_user_box_body-role"
    }, [_vm._v(_vm._s(_vm.card.get_user_shop_name))]), _c('p', {
      staticClass: "get_user_box_body-name"
    }, [_vm._v(_vm._s(_vm.card.get_user_name))])])]), _c('div', {
      staticClass: "give_user_box"
    }, [_c('div', {
      staticClass: "give_user_box_img"
    }, [_c('img', {
      attrs: {
        "src": _vm.getUserImage(_vm.card.give_user_image)
      }
    })]), _c('div', {
      staticClass: "give_user_box_body"
    }, [_c('p', {
      staticClass: "give_user_box_body-role"
    }, [_vm._v(_vm._s(_vm.card.give_user_shop_name))]), _c('p', {
      staticClass: "give_user_box_body-name"
    }, [_vm._v(_vm._s(_vm.card.give_user_name))])])])]), _c('div', {
      staticClass: "comment_box"
    }, [_c('div', {
      staticClass: "comment_box_img",
      on: {
        "click": function($event) {
          _vm.character1ImageSelect()
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getCharacter1ImageByImageName(_vm.card.character_1_folder_path, _vm.card.character_1_path)
      }
    })]), _c('div', {
      staticClass: "comment_box_body"
    }, [(!_vm.isInputMode && _vm.card.comments.length > 0) ? _c('p', {
      staticClass: "comment_box_body-text font_size",
      class: _vm.setClassCommentFontSize(),
      domProps: {
        "textContent": _vm._s(_vm.card.comments)
      },
      on: {
        "click": function($event) {
          _vm.setInputMode()
        }
      }
    }) : _vm._e(), (!_vm.isInputMode && _vm.card.comments.length === 0) ? _c('p', {
      staticClass: "comment_box_body-text not_entered",
      on: {
        "click": function($event) {
          _vm.setInputMode()
        }
      }
    }, [_vm._v("メッセージをここに書いてください。（※絵文字は使えません。最大140文字）")]) : _vm._e()])]), _c('div', {
      staticClass: "character_img_wrap"
    }, [_c('div', {
      staticClass: "character_img",
      on: {
        "click": function($event) {
          _vm.character2ImageSelect()
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getCharacter2ImageByImageName(_vm.card.character_2_path)
      }
    })])])])],
    [_c('div', {
      attrs: {
        "id": "philosophy"
      }
    }, [_vm._m(0), (!_vm.isInputedIdeas()) ? _c('div', {
      staticClass: "bg06 philosophy_validation"
    }, [_vm._m(1)]) : _vm._e(), _c('div', {
      staticClass: "bg06"
    }, [_c('div', {
      staticClass: "btn-select inner"
    }, [_c('nav', {
      staticClass: "btn-select__nav -bottom-line"
    }, [_c('h3', {
      staticClass: "btn-select__nav__title"
    }, [_vm._v("CSV")]), _c('button', {
      staticClass: "btn-select__nav__btn",
      class: _vm.setClassIdea('idea_peace_ming'),
      on: {
        "click": function($event) {
          _vm.setIdea('idea_peace_ming')
        }
      }
    }, [_c('span', [_vm._v("安心")])]), _c('button', {
      staticClass: "btn-select__nav__btn",
      class: _vm.setClassIdea('idea_sincere'),
      on: {
        "click": function($event) {
          _vm.setIdea('idea_sincere')
        }
      }
    }, [_c('span', [_vm._v("誠実")])]), _c('button', {
      staticClass: "btn-select__nav__btn",
      class: _vm.setClassIdea('idea_excitement'),
      on: {
        "click": function($event) {
          _vm.setIdea('idea_excitement')
        }
      }
    }, [_c('span', [_vm._v("感動")])]), _c('button', {
      staticClass: "btn-select__nav__btn",
      class: _vm.setClassIdea('idea_comfortable'),
      on: {
        "click": function($event) {
          _vm.setIdea('idea_comfortable')
        }
      }
    }, [_c('span', [_vm._v("快適")])]), _c('button', {
      staticClass: "btn-select__nav__btn",
      class: _vm.setClassIdea('idea_creation'),
      on: {
        "click": function($event) {
          _vm.setIdea('idea_creation')
        }
      }
    }, [_c('span', [_vm._v("創造")])])]), _c('nav', {
      staticClass: "btn-select__nav"
    }, [_c('h3', {
      staticClass: "btn-select__nav__title"
    }, [_vm._v("ESV")]), _c('button', {
      staticClass: "btn-select__nav__btn",
      class: _vm.setClassIdea('idea_civility'),
      on: {
        "click": function($event) {
          _vm.setIdea('idea_civility')
        }
      }
    }, [_c('span', [_vm._v("礼節")])]), _c('button', {
      staticClass: "btn-select__nav__btn",
      class: _vm.setClassIdea('idea_imagination'),
      on: {
        "click": function($event) {
          _vm.setIdea('idea_imagination')
        }
      }
    }, [_c('span', [_vm._v("想像")])]), _c('button', {
      staticClass: "btn-select__nav__btn",
      class: _vm.setClassIdea('idea_sympathy'),
      on: {
        "click": function($event) {
          _vm.setIdea('idea_sympathy')
        }
      }
    }, [_c('span', [_vm._v("感応")])]), _c('button', {
      staticClass: "btn-select__nav__btn",
      class: _vm.setClassIdea('idea_expression'),
      on: {
        "click": function($event) {
          _vm.setIdea('idea_expression')
        }
      }
    }, [_c('span', [_vm._v("表現")])]), _c('button', {
      staticClass: "btn-select__nav__btn",
      class: _vm.setClassIdea('idea_challenge_dream'),
      on: {
        "click": function($event) {
          _vm.setIdea('idea_challenge_dream')
        }
      }
    }, [_c('span', [_vm._v("挑夢")])])])])])])],
    [_c('div', {
      staticClass: "character1_select",
      class: {
        active: _vm.isCharacter1ImageSelect
      }
    }, [_c('swiper', {
      ref: "mySwiper",
      attrs: {
        "options": _vm.character1SwiperOption
      }
    }, _vm._l((_vm.character1Folder), function(folderIndex) {
      return _c('swiper-slide', [_c('ul', {
        staticClass: "main_list",
        class: _vm.setClassCharacter1Scroll(_vm.character1Image[folderIndex])
      }, _vm._l((_vm.character1Image[folderIndex]), function(character) {
        return _c('li', {
          staticClass: "main"
        }, [_c('img', {
          attrs: {
            "src": _vm.getCharacter1ImageByImageName(folderIndex, character)
          },
          on: {
            "click": function($event) {
              _vm.setCurrentCharacter1Image(folderIndex, character)
            }
          }
        })])
      }), 0)])
    }), 1), _c('ul', {
      staticClass: "tab_list"
    }, _vm._l((_vm.character1Folder), function(folderIndex, index) {
      return _c('li', {
        staticClass: "tab",
        class: _vm.setClassCurrentCharacter1ImageTab(index),
        on: {
          "click": function($event) {
            _vm.setCurrentCharacter1Tab(index)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.getCharacter1ImageByImageName(folderIndex, _vm.character1Image[folderIndex][0])
        }
      })])
    }), 0)], 1), _c('div', {
      staticClass: "character2_select",
      class: {
        active: _vm.isCharacter2ImageSelect
      }
    }, [_c('ul', {
      staticClass: "main_list",
      attrs: {
        "id": "main_list"
      }
    }, _vm._l((_vm.character2Image), function(character, characterIndex) {
      return _c('li', {
        staticClass: "main"
      }, [_c('img', {
        attrs: {
          "src": _vm.getCharacter2ImageByImageName(character)
        },
        on: {
          "click": function($event) {
            _vm.setCurrentCharacter2Image(character)
          }
        }
      })])
    }), 0)]), _c('div', {
      staticClass: "comment_input",
      class: {
        active: _vm.isInputMode
      }
    }, [_c('div', {
      staticClass: "comment_input_header"
    }, [_c('div', {
      staticClass: "comment_input_header_decision"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.setDisplayInit()
        }
      }
    }, [_vm._v("決定")])])]), (_vm.isInputMode) ? _c('p', {
      staticClass: "counter"
    }, [_vm._v(_vm._s(_vm.card.comments.length) + "/140文字")]) : _vm._e(), (_vm.isInputMode) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.card.comments),
        expression: "card.comments"
      }],
      ref: "esMycardComment",
      staticClass: "comment",
      attrs: {
        "maxlength": "140",
        "rows": "6",
        "placeholder": "メッセージをここに書いてください。（※絵文字は使えません。最大140文字）"
      },
      domProps: {
        "value": (_vm.card.comments)
      },
      on: {
        "change": function($event) {
          _vm.rmEmoji(_vm.card.comments)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.card, "comments", $event.target.value)
        }
      }
    }) : _vm._e()])], (_vm.showHeadsUpModal) ? [_c('div', {
      staticClass: "heads_up__modal"
    }, [_c('div', {
      staticClass: "heads_up__modal--overlay"
    }), _c('div', {
      staticClass: "heads_up__modal--main"
    }, [_vm._m(2), _vm._m(3), _c('div', {
      staticClass: "modal-main__buttons"
    }, [_c('a', {
      staticClass: "modal-main__buttons--normal",
      on: {
        "click": function($event) {
          _vm.showHeadsUpModal = false
        }
      }
    }, [_vm._v("カード登録へ"), _c('img', {
      staticClass: "modal-main__buttons--arrow-right",
      attrs: {
        "src": require("../images/arrow_right_blue.png")
      }
    })])])])])] : _vm._e()
  ], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "philosophy_title brown bold"
  }, [_vm._v("当てはまる理念を"), _c('br'), _vm._v("すべて選んでねだニャン！")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "philosophy_validation_wrap"
  }, [_c('p', {
    staticClass: "message"
  }, [_vm._v("該当する理念を選択してください")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "modal-main__title"
  }, [_vm._v("もらった相手が笑顔になる"), _c('span', [_vm._v("内容を書くニャン♪")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-main__cartoon"
  }, [_c('img', {
    staticClass: "modal-main__cartoon--image",
    attrs: {
      "src": require("../images/img_cat_right_hand.png"),
      "alt": "ねこ"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ea2a709!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/es-mycard-new.pug
// module id = 1422
// module chunks = 1